document.addEventListener('DOMContentLoaded', function () {
    // trigger a resize event when changing content tabs to ensure nested Compare & Select components are properly displayed
    document.querySelectorAll('.c-tabs__nav-link ').forEach(function (tabButton) {
        tabButton.addEventListener('click', function () {
            window.dispatchEvent(new CustomEvent('resize'));
        });
    });
});
